import _concat from "lodash/concat";
import invoicing from "./invoicing";

export default {
  path: "/invoicing",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(invoicing)
};
